import React from 'react';
import { CardButton } from './CardButton';
import './card.scss';

export const Card = ({
    ariaLabel,
    borderStyle = 'flat',
    children,
    className,
    disabled,
    href,
    selected = false,
    target,
    to,
    onClick,
    button = false
}) => {

    const primaryCardClasses = [
        `bsw-card`,
        `bsw-card--primary`,
        `bsw-card-border--${borderStyle}`,
        `${selected ? 'bsw-card--selected' : ''}`,
        `${disabled ? 'bsw-card--disabled' : ''}`,
        `${className ? className : ''}`
    ].join(' ');


    return (
        <>{(href || to || (button === true))
            ? <CardButton
                ariaLabel={ariaLabel}
                borderStyle={borderStyle}
                className={className}
                disabled={disabled}
                href={href}
                to={to}
                target={target}
                onClick={onClick}>
                {children}
            </CardButton>
            : <div
                className={primaryCardClasses}
                onClick={onClick}>
                {children}
            </div>
        }</>
    )
}